/* ======================================================
   Inhalte der Startseite – zentral gesammelt.
   Alles entspricht den echten Funktionen der Software,
   nichts ist erfunden.
====================================================== */

export const TRUST_POINTS = [
  { icon: "mdi:map-marker-outline", text: "Hosting ausschließlich in Deutschland" },
  { icon: "mdi:shield-check-outline", text: "DSGVO-konform" },
  { icon: "mdi:timer-sand", text: "1 Monat kostenlos, ohne Kosten" },
];

export const HIGHLIGHTS = [
  {
    icon: "fluent:people-audience-32-filled",
    title: "Mitglieder & Verträge",
    text: "Alle Mitglieder mit Vertrag, Gürtelgrad und Notizen an einem Ort – auch über mehrere Standorte hinweg.",
    href: "/mitgliederverwaltung",
  },
  {
    icon: "carbon:piggy-bank",
    title: "Direkte digitale Abbuchung",
    text: "Monatsbeiträge mit einem Klick abrechnen – mit Vorschau, bevor etwas abgebucht wird. Ganz ohne SEPA-Datei und Bank-Upload.",
    href: "/digitale-beitragsabbuchung",
  },
  {
    icon: "healthicons:i-exam-multiple-choice",
    title: "Gürtelprüfungen",
    text: "Prüfungen planen, Teilnehmer entscheiden, Gebühren einziehen und Listen als PDF drucken.",
    href: "/guertelpruefungen",
  },
  {
    icon: "mdi:file-document-outline",
    title: "Rechnungen & Steuer",
    text: "Rechnungen entstehen automatisch. Für den Steuerberater exportierst du alles gesammelt als ZIP.",
  },
];

export const ALL_FEATURES = [
  "Mitgliederverwaltung mit Verträgen & Notizen",
  "Mehrere Standorte",
  "Eigenes Gürtelsystem frei konfigurierbar",
  "Direkte digitale Abbuchung mit Vorschau – ohne SEPA-Datei",
  "Abbuchungs-Historie mit Suche",
  "Gürtelprüfungen planen & abrechnen",
  "Prüfungslisten als PDF – sortiert & gruppiert",
  "Beitrags- & Gebührenkonfiguration",
  "Mitgliedschaften pausieren & kündigen",
  "Automatische Rechnungen als PDF",
  "E-Mail-Versand über dein eigenes Postfach",
  "Steuerberater-Export als ZIP",
  "Vertrags-PDFs individuell gestaltbar",
  "Data-Health-Check für Mitgliederdaten",
  "Benutzer & Rollen für dein Trainerteam",
  "Zwei-Faktor-Authentifizierung",
  "Dashboard mit Statistiken & Geburtstagen",
  "Geführte Touren durch jede Funktion",
];

export const STEPS = [
  {
    number: "01",
    title: "Registrieren",
    text: "Schule anlegen und 1 Monat kostenlos testen – ohne Kosten während der Testphase.",
  },
  {
    number: "02",
    title: "Einrichten",
    text: "Standorte, Beiträge und Mitglieder anlegen. Bankdaten einmal hinterlegen – den Rest übernimmt die Software.",
  },
  {
    number: "03",
    title: "Abrechnen",
    text: "Monat wählen, Vorschau prüfen, bestätigen – die Abbuchung geht direkt digital raus. Keine SEPA-Datei, kein Bank-Upload.",
  },
];

export const PRICE_TIERS = [
  { label: "Bis 20 Mitglieder", price: "19,00 €" },
  { label: "21 – 50 Mitglieder", price: "34,00 €" },
  { label: "51 – 100 Mitglieder", price: "49,00 €" },
  { label: "101 – 200 Mitglieder", price: "59,00 €" },
  { label: "Über 200 Mitglieder", price: "75,00 €" },
];

export const CONDITIONS = [
  "1 Monat kostenlose Testphase",
  "Alle Funktionen in jedem Tarif enthalten",
  "Quartalsweise Abrechnung",
  "Mindestlaufzeit 12 Monate, Verlängerung um 12 Monate",
  "Kündigung mit 4 Wochen Frist zum Laufzeitende",
];

export const FAQ_ITEMS = [
  {
    q: "Was bedeutet „direkt digital abbuchen“?",
    a: "Du prüfst wie gewohnt eine Vorschau der fälligen Beiträge – bestätigst du sie, reicht MartialVerse die Abbuchung direkt digital ein. Du musst keine SEPA-Datei mehr exportieren und manuell im Online-Banking deiner Bank hochladen.",
  },
  {
    q: "Wie läuft die 1 Monat kostenlose Testphase ab?",
    a: "Du registrierst deine Schule und nutzt alle Funktionen der Software einen Monat lang ohne Kosten. Erst danach beginnt die reguläre, nach Mitgliederzahl gestaffelte Abrechnung.",
  },
  {
    q: "Wo liegen meine Daten?",
    a: "Ausschließlich auf Servern in Deutschland (Hetzner Online GmbH). Eine Übermittlung in Drittländer findet nicht statt, sensible Daten wie Bankverbindungen werden verschlüsselt gespeichert.",
  },
  {
    q: "Wie lange ist die Vertragslaufzeit?",
    a: "Die Mindestlaufzeit beträgt 12 Monate und verlängert sich automatisch um weitere 12 Monate, sofern nicht mit 4 Wochen Frist zum Laufzeitende gekündigt wird.",
  },
  {
    q: "Was kostet MartialVerse nach der Testphase?",
    a: "Du zahlst nach Mitgliederzahl – von 19 € im Monat bis 20 Mitglieder bis 75 € im Monat für über 200 Mitglieder, zzgl. 19 % MwSt. Alle Funktionen sind in jedem Tarif enthalten.",
  },
  {
    q: "Kann ich meine Daten exportieren?",
    a: "Ja. Prüfungslisten, Rechnungen und ein gesammelter Steuerberater-Export als ZIP stehen jederzeit zur Verfügung – die regelmäßige Sicherung deiner Daten liegt in deiner Verantwortung.",
  },
];
